"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenterListRequest = void 0;
var CenterListRequest = /** @class */ (function () {
    function CenterListRequest() {
    }
    return CenterListRequest;
}());
exports.CenterListRequest = CenterListRequest;
;
//# sourceMappingURL=centerList.request.js.map